import { createSlice } from "@reduxjs/toolkit";
import lod_ from "lodash";

const initialState = {
	chatbot: null,
	knowledgeBaseChatbot: null,
	disableRouting: false,
	changeRoute: false,
	config: {
		maxFileSizes: {
			default: 20 // Default: 20MB
		}
	},
	stuckAction: {
		status: false,
		cancel: () => {},
		save: () => {},
		next: () => {},
		openDialog: false
	},
	formV2Dialogs: []
};

export const error = initialState;

const slice = createSlice({
	name: "application",
	initialState,
	reducers: {
		initKnowledgeBaseChatbotScript: (state, action) => {
			state.knowledgeBaseChatbot = {
				active: action.payload.active,
				apiKey: action.payload.apiKey,
				scriptUrl: action.payload.scriptUrl,
				metadatas: action.payload.metadatas
			};
		},
		initChatbotScript: (state, action) => {
			state.chatbot = {
				active: action.payload.active,
				apiKey: action.payload.apiKey,
				scriptUrl: action.payload.scriptUrl,
				metadatas: action.payload.metadatas
			};
		},
		setDisableRouting: (state, action) => {
			state.disableRouting = true;
		},
		setEnableRouting: (state, action) => {
			state.disableRouting = false;
		},
		changeRouteHandle: (state, action) => {
			state.changeRoute = action.payload;
		},
		setStuckAction: (state, action) => {
			state.stuckAction = action.payload;
		},
		resetStuckAction: state => {
			state.stuckAction = initialState.stuckAction;
		},
		closeStuckDialog: state => {
			state.stuckAction.openDialog = false;
		},
		openStuckDialog: (state, action) => {
			state.stuckAction.openDialog = true;
			state.stuckAction.next = action.payload;
		},
		openFormV2Dialog: (state, action) => {
			const payload = action.payload ?? {};

			state.formV2Dialogs.push({
				id: payload.id ?? `formV2_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
				dictionary: payload.dictionary ?? {},
				item: payload.item ?? {},
				defaultValues: payload.defaultValues ?? payload.defaultValue ?? {},
				edit: payload.edit === true,
				disabled: payload.disabled === true,
				target: payload.target,
				resource: payload.resource,
				save: payload.save ?? {}
			});
		},
		closeFormV2Dialog: (state, action) => {
			const id = action.payload?.id;

			if (lod_.isNil(id)) {
				state.formV2Dialogs = state.formV2Dialogs.slice(0, -1);
				return;
			}

			state.formV2Dialogs = state.formV2Dialogs.filter(dialog => dialog.id !== id);
		},
		resetFormV2Dialogs: state => {
			state.formV2Dialogs = [];
		},
		setConfig: (state, action) => {
			state.config = { ...state.config, ...action.payload };
		}
	}
});

export const selectConfig = state => state.application?.config;

export const selectMaxFileSizes = state => state.application?.config?.maxFileSizes;

export const getKnowledgeBaseChatbotConfig = state => state.application.knowledgeBaseChatbot;

export const isRoutingDisabled = state => state.application.disableRouting;

export const getStuckAction = state => state.application.stuckAction;

export const getFormV2Dialogs = state => state.application.formV2Dialogs;

export const getChatbotConfig = state => state.application.chatbot;

/**
 * Get maximum file size by type
 * @param {object} state - Redux state
 * @param {string} type - File type (e.g., 'document', 'image', 'video')
 * @returns {number} Maximum file size in bytes
 */
export const selectMaxFileSizeByType = (state, type) => {
	const maxFileSizes = state.application?.config?.maxFileSizes;

	if (lod_.isNil(maxFileSizes)) {
		return {
			mo: 20,
			bytes: 20 * 1024 * 1024
		};
	}

	const defaultMO = maxFileSizes[type] ?? maxFileSizes.default ?? 20;
	return {
		mo: defaultMO,
		bytes: defaultMO * 1024 * 1024
	};
};

export const {
	initChatbotScript,
	initKnowledgeBaseChatbotScript,
	setDisableRouting,
	setEnableRouting,
	changeRouteHandle,
	setConfig,
	setStuckAction,
	resetStuckAction,
	closeStuckDialog,
	openStuckDialog,
	openFormV2Dialog,
	closeFormV2Dialog,
	resetFormV2Dialogs
} = slice.actions;

export default slice.reducer;
